/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint fault moment dictionary
 */
export enum FalconComplaintFaultMoment {
  BeforeAssembly = 0,
  DuringAssembly,
  DuringUse,
  AfterCollision
}
